import React from "react"
export default function ({ lineColor }) {
  return (
    <div>
      <hr
        style={{
          margin: 0,
          color: lineColor,
          backgroundColor: lineColor,
        }}
      />
    </div>
  )
}
